import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { MenuComponent } from './menu-component';
import { AmbienteService } from '../../providers/ambiente-service';

@NgModule({
  declarations: [
    MenuComponent
  ],
  imports: [
    IonicModule.forRoot(MenuComponent)
  ],
  bootstrap: [
    IonicApp
  ],
  entryComponents: [
    MenuComponent
  ],
  exports: [MenuComponent],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AmbienteService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA ]
})
export class MenuModule { }


// WEBPACK FOOTER //
// ./src/components/menu-component/menu.module.ts